export default "__VITE_ASSET__b7990c2b__"